import { StackNavigationProp } from '@react-navigation/stack';

import { RouteProp } from '@react-navigation/native';

import { Tag } from '../api/adserver';

export enum RouteNames {
  Explore = 'Explore',
  Results = 'Results',
  Condo = 'Condo',
  News = 'News',
  Gallery = 'Gallery',
  CommunityCalendar = 'CommunityCalendar',
  CommunityAgenda = 'CommunityAgenda',
  ExploreTab = 'Compass',
  CondoTab = 'Building',
  Ledger = 'Ledger',
  ServiceRequest = 'ServiceRequest',
  CreateServiceRequest = 'CreateServiceRequest',
  Feedback = 'Feedback',
  Contest = 'Contest',
  ProfileStack = 'ProfileStack',
}

export type RootStackParamList = {
  Explore: undefined;
  Results: {
    query: string;
    age?: null | number;
    tag?: Tag;
  };
  Condo: undefined;
  News: undefined;
  Gallery: undefined;
  CommunityCalendar: undefined;
  CommunityAgenda: undefined;
  ExploreTab: undefined;
  CondoTab: undefined;
  Ledger: undefined;
  ServiceRequest: undefined;
  CreateServiceRequest: undefined;
  Feedback: undefined;
  Contest: undefined;
};

export type ResultsScreenRouteProp = RouteProp<
  RootStackParamList,
  RouteNames.Results
>;

export type ResultsScreenNavigationProp = StackNavigationProp<
  RootStackParamList,
  RouteNames.Results
>;

export type ResultsProps = {
  route: ResultsScreenRouteProp;
  navigation: ResultsScreenNavigationProp;
};

export type ExploreScreenRouteProp = RouteProp<
  RootStackParamList,
  RouteNames.Explore
>;

export type LedgerScreenRouteProp = RouteProp<
  RootStackParamList,
  RouteNames.Ledger
>;

export type LedgerScreenNavigationProp = StackNavigationProp<
  RootStackParamList,
  RouteNames.Ledger
>;

export type ExploreScreenNavigationProp = StackNavigationProp<
  RootStackParamList,
  RouteNames.Explore
>;

export type ExploreProps = {
  route: ExploreScreenRouteProp;
  navigation: ExploreScreenNavigationProp;
  key?: string;
};

export type LedgerProps = {
  route: LedgerScreenRouteProp;
  navigation: LedgerScreenNavigationProp;
  key?: string;
};

export type ServiceRequestScreenRouteProp = RouteProp<
  RootStackParamList,
  RouteNames.ServiceRequest
>;

export type ServiceRequestNavigationProp = StackNavigationProp<
  RootStackParamList,
  RouteNames.Results
>;

export type ServiceRequestProps = {
  route: ResultsScreenRouteProp;
  navigation: ResultsScreenNavigationProp;
};

export type CreateServiceRequestRouteProp = RouteProp<
  RootStackParamList,
  RouteNames.CreateServiceRequest
>;

export type CreateServiceRequestNavigationProp = StackNavigationProp<
  RootStackParamList,
  RouteNames.CreateServiceRequest
>;

export type CreateServiceRequestProps = {
  route: CreateServiceRequestRouteProp;
  navigation: CreateServiceRequestNavigationProp;
};

export type FeedbackRouteProp = RouteProp<
  RootStackParamList,
  RouteNames.Feedback
>;

export type FeedbackNavigationProp = StackNavigationProp<
  RootStackParamList,
  RouteNames.Feedback
>;

export type FeedbackRequestProps = {
  route: FeedbackRouteProp;
  navigation: FeedbackNavigationProp;
};
